var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.469 5.063a.844.844 0 100-1.688.844.844 0 000 1.688zM11.531 5.063a.844.844 0 100-1.688.844.844 0 000 1.688zM6.469 9.844a.844.844 0 100-1.688.844.844 0 000 1.688zM11.531 9.844a.844.844 0 100-1.688.844.844 0 000 1.688zM6.469 14.625a.844.844 0 100-1.688.844.844 0 000 1.688zM11.531 14.625a.844.844 0 100-1.688.844.844 0 000 1.688z",
    fill: "#1E355C"
  })));
}
export default SvgDragDots;